<template>
  <el-dialog width="1200px" title="Status Track" :close-on-click-modal="false" :visible.sync="visible" top="3vh">
    <div class="pb20">
      <el-descriptions :column="3" size="medium" border :labelStyle="{ width: '120px' }">
        <el-descriptions-item :contentStyle="{ width: '90px' }">
          <span slot="label">Quotation (V)</span>
          {{ detailInfo.adjustmentNo || "" }}
        </el-descriptions-item>
        <el-descriptions-item :contentStyle="{ width: '90px' }">
          <span slot="label">Trans No.</span>
          {{ detailInfo.applymentNo || "" }}
        </el-descriptions-item>
        <el-descriptions-item>
          <span slot="label">Billing Party</span>
          {{ detailInfo.billingParty || "" }}
        </el-descriptions-item>
      </el-descriptions>

      <div class="pt14">
        <el-table border :data="dataList" v-loading="dataListLoading" style="width: 100%">
          <el-table-column prop="createAt" align="center" label="Handling Time" width="164">
            <template slot-scope="scope">
              {{ scope.row.createAt | parseTimeSecond }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="Status" width="100">
            <template slot-scope="scope">
              <p>{{ adjustmentStatusFormat(scope.row.adjustmentStatus) }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="remark" align="center" label="Description / Remark" min-width="120" />
          <el-table-column prop="userInfo" align="center" label="Handler" width="130">
            <template slot-scope="scope">
              <span>{{ scope.row.userInfo.nickname }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagination
          :current="current"
          :pageSize="pageSize"
          :totalCount="totalCount"
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
        ></pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import filtersMixin from "@/mixins/filtersMixin";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [filtersMixin, paginationMixin, formatterMixin],
  components: {
    Pagination,
  },
  data() {
    return {
      visible: false,
      dataList: [],
      dataListLoading: false,
      dataForm: {
        adjustmentId: null,
      },
      detailInfo: {},
    };
  },
  methods: {
    // 初始化
    async init(data) {
      this.visible = true;
      await this.$nextTick();
      this.dataForm = {
        adjustmentId: data.id,
      };
      this.detailInfo = data || {};
      this.getDataList(1);
    },
    // 获取分页
    getDataList(current) {
      setTimeout(async () => {
        this.dataListLoading = true;
        if (current) {
          this.current = current;
        }
        const { code, data } = await this.$http.get("/admin/adjustmentLog/paging", {
          params: {
            current: this.current,
            size: this.pageSize,
            "orders[0].asc": false,
            "orders[0].column": "id",
            ...this.dataForm,
          },
        });
        if (code === 200) {
          this.dataList = data.records;
          this.totalCount = data.total;
        } else {
          this.dataList = [];
          this.totalCount = 0;
        }
        this.dataListLoading = false;
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped></style>
